import { PropertyFilterFormModel } from '../../components/property-filter-form/PropertyFilterForm';

export function mapPropertyFilterFormModelToSearchCriteria(values: PropertyFilterFormModel) {
  return ({
    place: values.place,
    minPrice: values.price?.min ? parseInt(values.price.min, 10) : undefined,
    maxPrice: values.price?.max ? parseInt(values.price.max, 10) : undefined,
    minSize: values.size?.min ? parseInt(values.size.min, 10) : undefined,
    maxSize: values.size?.max ? parseInt(values.size.max, 10) : undefined,
  });
}
